import StarterKit from '@tiptap/starter-kit';
import HardBreak from '@tiptap/extension-hard-break';
import Link from '@tiptap/extension-link';
import { CodeBlockLowlight } from '@tiptap/extension-code-block-lowlight';
import { createLowlight } from 'lowlight';
import { BugherdMentionWithReactView } from './bugherdMentionReactView';
import { CORE_LANGUAGE_GRAMMARS } from './codeLanguages';

export const EDITOR_LINK_CLASS = 'rich-text-description-link';

export const sharedLowlight = createLowlight(CORE_LANGUAGE_GRAMMARS);

export function createBugherdLinkExtension(options: { openOnClick: boolean }) {
  return Link.configure({
    openOnClick: options.openOnClick,
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      ...(options.openOnClick
        ? { target: '_blank', class: EDITOR_LINK_CLASS }
        : {})
    }
  });
}

export const SubmitOnModEnterHardBreak = HardBreak.extend({
  addKeyboardShortcuts() {
    return {
      'Shift-Enter': () => this.editor.commands.setHardBreak()
    };
  }
});

export function createRichTextEditorStarterKit(options?: {
  submitOnModEnter?: boolean;
}) {
  return StarterKit.configure({
    heading: { levels: [1, 2, 3, 4] },
    codeBlock: false,
    ...(options?.submitOnModEnter ? { hardBreak: false } : {})
  });
}

export function createMarkdownPreviewStarterKit() {
  return StarterKit.configure({
    heading: { levels: [1, 2, 3, 4] },
    codeBlock: false
  });
}

export function createMarkdownPreviewCodeBlock() {
  return CodeBlockLowlight.configure({
    lowlight: sharedLowlight,
    defaultLanguage: null
  });
}

export { BugherdMentionWithReactView };

/** ProseMirror JSON fragment for a linked run + trailing space (no HTML strings). */
export function createLinkedTextInsertContent(href: string, displayText: string) {
  return [
    {
      type: 'text' as const,
      text: displayText,
      marks: [
        {
          type: 'link' as const,
          attrs: {
            href,
            target: '_blank',
            rel: 'noopener noreferrer',
            class: EDITOR_LINK_CLASS
          }
        }
      ]
    },
    { type: 'text' as const, text: ' ' }
  ];
}
